import React from "react";
import logo from "../../assets/images/maestro-logo.png";
import { Link } from "react-router-dom";
import { LOADNOW_ENV_BASE_URL } from "../../App/serverConfig";
import {LandingPageMessages} from "../../App/components/Applications/AppLandingPage/MaestroAppLandingPages/LandingPageContents";


export default (props) => {
	return (
		<nav
			className='navbar navbar-expand-lg navbar-light navbar-default navbar-fixed-top past-main shadow-sm bg-white rounded'
			role='navigation'
		>
			<div className='container-fluid'>
				<a
					className='page-scroll'
					href='https://maestroplatform.azurewebsites.net/'
				>
					<img src={logo} alt='Maestro Logo' />
				</a>
				<button
					className='navbar-toggler'
					type='button'
					data-toggle='collapse'
					data-target='#navbarSupportedContent'
					aria-controls='navbarSupportedContent'
					aria-expanded='false'
					aria-label='Toggle navigation'
				>
					<span className='navbar-toggler-icon' />
				</button>
				{
					// props.hasRole ? (
					<div className='collapse navbar-collapse' id='navbarSupportedContent'>
						<ul className='navbar-nav mr-auto' />
						<ul className='navbar-nav my-2 my-lg-0'>
							<li className='nav-item'>
								<a
									href={LandingPageMessages.navbarlink}
									className='nav-link'
								>
									{" "}
									Home{" "}
								</a>
							</li>
							<li className='nav-item'>
								<Link to={"/ie/ieplatform"} className='nav-link'>
									{" "}
									Maestro{" "}
								</Link>
							</li>

							<li className='nav-item dropdown'>
								<a
									className='nav-link dropdown-toggle'
									href='#/'
									id='navbarDropdown'
									role='button'
									data-toggle='dropdown'
									aria-haspopup='true'
									aria-expanded='false'
								>
									Applications
								</a>
								<div className='dropdown-menu' aria-labelledby='navbarDropdown'>
									{/* 	<Link to={"/landing/loadnow"} className='nav-link'>
										{" "}
										LoadNow{" "}
									</Link> */}
									<a
										target='_blank'
										rel='noopener noreferrer'
										href={LOADNOW_ENV_BASE_URL}
										title='LoadNow'
										className='nav-link'
									>
										LoadNow
									</a>
									<Link to={"/landing/commercialinsight"} className='nav-link'>
										{" "}
										Commercial{" "}
									</Link>
								</div>
							</li>

							<li className='nav-item'>
								<Link to={"/landing/academy"} className='nav-link'>
									Academy
								</Link>
							</li>
						</ul>
					</div>
					//) : null
				}
			</div>
		</nav>
	);
};
